export const monthData = [
  {
    month: "JAN",
    holiday: "Seollal",
    description:
      "Seollal is a customary celebration and a nationally recognized day that honors the start of the lunisolar calendar. It is one of the most significant traditional festivals for Koreans.",
    food_name: "Tteokguk",
    food_name_eng: "rice cake soup",
    Ingredients: [
      "beef",
      "egg",
      "fish sauce",
      "garlic",
      "scallion",
      "black pepper",
      "sesame oil",
      "rice cake",
      "soy sauce",
    ],
  },

  {
    month: "JAN",
    holiday: "Daeboreum",
    description:
      "Daeboreum is a Korean holiday when the full moon rises, celebrating the first full moon of the Korean Lunar New Year. The representative food is five-grain rice, which is eaten as a wish for a good harvest.",
    food_name: "Ogok-bap",
    food_name_eng: "five-grain rice",
    Ingredients: [
      "rice",
      "proso millet",
      "sorghum",
      "black beans",
      "red beans",
    ],
  },

  {
    month: "FEB",
    holiday: "Hansik",
    description:
      "Hansik means eating cold food. Traditionally, people eat cold food made the day before without using fire. It's February of the lunar calendar, and sometimes it can be March of the lunar calendar",
    food_name: "",
    food_name_eng: "",
    Ingredients: [""],
  },

  {
    month: "MAY",
    holiday: "Dano",
    description:
      "Dano is a ritual to pray for a good harvest after rice planting. Also, It is held before the start of a hot summer day, so it means to maintain your body and get rid of bad energy. The most representative food is Surichwi Tteok, which is a plant that grows on high mountains anywhere in Korea and is rich in nutrients.",
    food_name: "Surichwi Tteok",
    food_name_eng: "rice cake",
    Ingredients: ["rice powder", "mugwort powder", "sesame oil"],
  },

  {
    month: "AUG",
    holiday: "Chuseok",
    description:
      "Chuseok is a day to celebrate and appreciate the good harvest and to offer sacrifices to ancestors in the wake of the harvest season as an agricultural nation.",
    food_name: "Jjeon",
    food_name_eng: "",
    Ingredients: [
      "soy sauce",
      "vinegar",
      "sesame oil",
      "garlic",
      "sesame seed",
      "prawn",
      "black pepper",
      "flour",
      "corn starch",
      "egg",
      "vegetable oil",
      "onion",
      "chili pepper",
    ],
  },

  {
    month: "AUG",
    holiday: "Chuseok",
    description:
      "Chuseok is a day to celebrate and appreciate the good harvest and to offer sacrifices to ancestors in the wake of the harvest season as an agricultural nation.",
    food_name: "Songpyeon",
    food_name_eng: "half-moon shaped rice cakes",
    Ingredients: ["rice powder", "sesame seed", "mung bean", "sesame oil"],
  },

  {
    month: "AUG",
    holiday: "Chuseok",
    description:
      "Chuseok is a day to celebrate and appreciate the good harvest and to offer sacrifices to ancestors in the wake of the harvest season as an agricultural nation.",
    food_name: "Galbi",
    food_name_eng: "grilled rib",
    Ingredients: [
      "beef short rib",
      "soy sauce",
      "sugar",
      "honey",
      "sesame oil",
      "asian pear",
      "onion",
      "scallion",
      "garlic",
      "ginger",
      "black pepper",
      "sesame seed",
    ],
  },

  {
    month: "NOV",
    holiday: "Dongzhi",
    description:
      "Dongzhi is one of the most important Asian festivals. It is December in the Gregorian calendar and November in the lunar calendar.",
    food_name: "Patjuk",
    food_name_eng: "red bean porridge",
    Ingredients: ["rice", "red beans"],
  },
];
